import React from 'react';
/* eslint-disable */
export function CheckCircleBroken(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none" {...props}>
      <path
        d="M64.1673 32.8335V35.5169C64.1637 41.8064 62.1271 47.9263 58.3612 52.9638C54.5953 58.0014 49.3019 61.6866 43.2704 63.4699C37.239 65.2532 30.7927 65.0391 24.8929 62.8594C18.9931 60.6797 13.9559 56.6513 10.5326 51.375C7.10934 46.0986 5.48338 39.857 5.89721 33.5811C6.31104 27.3052 8.7425 21.3311 12.829 16.55C16.9154 11.7688 22.4379 8.43672 28.5729 7.05062C34.7078 5.66451 41.1264 6.29867 46.8715 8.85853M64.1673 12.1668L35.0006 41.3627L26.2506 32.6127"
        stroke="url(#paint0_linear_469_3757)"
        strokeWidth="4.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_469_3757"
          x1="35.0007"
          y1="64.6668"
          x2="35.0007"
          y2="6.3335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF512F" />
          <stop offset="1" stopColor="#DD2476" />
        </linearGradient>
      </defs>
    </svg>
  );
}
